import { Form, Button } from "react-bootstrap";
import { MdArrowBack } from "react-icons/md";
import DoctorProfileForm from "../../forms/DoctorProfileForm";
import { mergeDoctorProfileFormData } from "../../utils/doctorFormHelpers";

const CreateDoctorProfileScreen = ({
  formData,
  onChange,
  onSave,
  onBack,
  saving,
  savedDoctor,
  specialties,
  medicalProcedures,
  specializations,
  departments,
  designations,
  degrees,
  accreditations,
  establishments = [],
  userTypes = [],
  locationTypes,
  locations,
}) => {
  const effectiveFormData = mergeDoctorProfileFormData(savedDoctor, formData);

  return (
    <div className="create-profile-screen">
      <div className="hm-topbar create-profile-screen__topbar">
        <div className="hm-brand">
          <button type="button" className="create-profile-screen__back" onClick={onBack} aria-label="Back">
            <MdArrowBack />
          </button>
          <span>Complete Doctor Profile</span>
        </div>
      </div>

      <p className="create-profile-screen__hint">
        Fill in your professional details, contact information, and social profiles below.
      </p>

      <Form
        noValidate
        onSubmit={(e) => {
          e.preventDefault();
          onSave();
        }}
      >
        <DoctorProfileForm
          formMode="doctor"
          formData={effectiveFormData}
          onChange={onChange}
          establishments={establishments}
          userTypes={userTypes}
          specialties={specialties}
          medicalProcedures={medicalProcedures}
          specializations={specializations}
          departments={departments}
          designations={designations}
          degrees={degrees}
          accreditations={accreditations}
          locationTypes={locationTypes}
          locations={locations}
        />

        <div className="authdata-form-actions create-profile-screen__actions">
          <Button type="button" variant="outline-secondary" onClick={onBack} disabled={saving}>
            Cancel
          </Button>
          <Button type="submit" variant="primary" className="btn-submit" disabled={saving}>
            {saving ? "Saving…" : "Save Profile"}
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default CreateDoctorProfileScreen;
